<!-- Clean layout - no debug elements -->

<div class="upload-doc-content" data-test="uploaded-form" data-testid="uploaded-form">

  @if (!isUploading) {

  <div>
    @if (uploadedFile && !isExtractionSupported) {
    <div class="added-file">
      <div class="added-icon" (click)="viewDocument(uploadedFile)">
        <div class="added-display-icon">
          <mat-icon svgIcon="icon-file-blue" class="added-icon-color"></mat-icon>
        </div>
        <div class="file-name" data-test="uploaded-file-name" data-testid="uploaded-file-name">
          <p>{{ uploadedFile.fileName }}</p>
        </div>
      </div>
      <div class="delete-icon" (click)="deleteDocuments(uploadedFile)" data-testid="delete-uploaded-file">
        <mat-icon svgIcon="delete-icon"></mat-icon>
      </div>
    </div>
    }
    <!--- Toggle Buttons -->

    @if (!hideTabs) {
    <div>
      @if (!uploadedFile) {
        @if (isRequested) {
          <!-- Show only the pending message without tabs when carrier upload is already requested -->
          <div class="tab-content">
            <div class="document-requested" data-testid="carrier-upload-pending">
              <mat-icon svgIcon="upload-file-tree"></mat-icon><span class="padding-left-sm request-upload">Document upload
                pending</span>
            </div>
            <div fxLayoutAlign="space-around center" class="padding-top-lg">
              <span class="heading">Carrier upload requested. </span>
              <span class="body padding-top-sm">You will be able to view and download the document once the Carrier
                uploads.</span>
            </div>
            @if (canUndoCarrierRequest) {
              <button
                type="button"
                class="undo-request-banner"
                (click)="onUndoRequestCarrier()"
                data-test="undo-request-btn"
                data-testid="undo-request-btn"
              >
                <mat-icon>undo</mat-icon>
                <span class="padding-left-sm request-upload">Undo Request</span>
              </button>
            }
          </div>
        } @else {
          <!-- Show tabs when carrier upload has not been requested yet -->
          <div class="tab-toggle">
            <mat-tab-group animationDuration="0ms" mat-align-tabs="center" mat-stretch-tabs="true"
              [selectedIndex]="selectedTabIndex"
              (selectedTabChange)="isRequestCollect($event)">
              <mat-tab label="Add File">
                <div class="tab-content">
                  <ng-template [ngTemplateOutlet]="additonalDocumentUpload"></ng-template>
                </div>
              </mat-tab>
              <mat-tab label="Request Carrier">
                <div class="tab-content">
                  <div class="add-file-request" (click)="onRequestCarrierUpload()" data-testid="request-carrier-upload">
                    <mat-icon svgIcon="upload-file-tree"></mat-icon><span class="padding-left-sm request-upload">Request
                      Carrier Upload</span>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        }
      }
    </div>
    } @else {
      <form [formGroup]="form">

        <!-- ── Upload card (extraction-supported docs: always on top) ── -->
        @if (isExtractionSupported) {
          <div class="doc-upload-area" data-testid="doc-upload-card">

            @if (!uploadedFile) {
              <!-- Empty state: prompt to upload -->
              <img src="assets/images/dl-front.png" class="doc-upload-placeholder" alt="document placeholder" />
              <p class="doc-upload-hint" data-testid="doc-upload-hint">Take a photo or upload to auto-fill the details</p>
              <button
                mat-stroked-button
                class="doc-upload-button"
                type="button"
                (click)="onAddFileClick(pictureSingle, uploadMultiple)"
                [disabled]="isUploading"
                data-testid="uploadBtn-enabled">
                <mat-icon>add</mat-icon>
                Add File
              </button>
              <div class="doc-upload-info">
                <mat-icon class="doc-info-icon">info_outline</mat-icon>
                <span>JPEG, JPG, PNG or PDF supported</span>
              </div>
            } @else {
              <!-- File uploaded: show file row + extraction status -->
              <!-- File preview + file row -->
              @if (previewUrl) {
                <!-- Image preview with file row below -->
                <div class="doc-preview-container">
                  <img [src]="previewUrl" class="doc-preview-image" alt="Document preview" />
                </div>
                <div class="doc-uploaded-row">
                  <div class="doc-uploaded-file">
                    <mat-icon svgIcon="icon-file-blue" class="doc-file-icon"></mat-icon>
                    <span class="doc-file-name">{{ uploadedFile.fileName }}</span>
                  </div>
                  <mat-icon class="doc-delete-icon" (click)="clearUploadedFile()" data-testid="clear-file-btn">delete</mat-icon>
                </div>
              } @else {
                <!-- PDF: single row with icon + name + delete -->
                <div class="doc-uploaded-row doc-uploaded-row--pdf">
                  <div class="doc-preview-pdf-inline">
                    <mat-icon class="doc-preview-pdf-inline__icon">picture_as_pdf</mat-icon>
                    <span class="doc-preview-pdf-inline__name">{{ uploadedFile.fileName }}</span>
                  </div>
                  <mat-icon class="doc-delete-icon" (click)="clearUploadedFile()" data-testid="clear-file-btn">delete</mat-icon>
                </div>
              }

              @if (isExtracting) {
                <div class="extraction-banner extraction-banner--loading" data-testid="extraction-banner">
                  <mat-spinner diameter="16" class="extraction-spinner"></mat-spinner>
                  <span class="extraction-banner__text">Reading your document...</span>
                </div>
              } @else if (extractionFailed) {
                <div class="extraction-banner extraction-banner--failed" data-testid="extraction-banner-failed">
                  <mat-icon class="extraction-banner__icon">edit</mat-icon>
                  <span class="extraction-banner__text">Couldn't read the document. Please fill in the fields below.</span>
                </div>
              } @else {
                <div class="extraction-banner" data-testid="extraction-banner">
                  <mat-icon class="extraction-banner__icon">auto_awesome</mat-icon>
                  <span class="extraction-banner__text">AI auto-filled the fields below. Review and edit if needed.</span>
                </div>
              }
            }

          </div>

          <!-- Expired document warning -->
          @if (extractionWarning) {
            <div class="extraction-warning" data-testid="extraction-warning">
              <mat-icon class="extraction-warning__icon">warning</mat-icon>
              <span class="extraction-warning__text">{{ extractionWarning }}</span>
            </div>
          }
        }

        @if (!isFastCard && !isHealthCard && !isTrainingDocument && !isPRCard) {
        <div class="view-date" [class.skeleton-field]="isExtracting">
          @if (!isExtracting) {
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Issue Date</mat-label>
            <input matInput [matDatepicker]="generationDate" formControlName="generationDate" required
              [max]="currentDate" [disabled]="uploadedFile && !isExtractionSupported" data-test="generation-date" data-testid="generation-date"
              readonly (focus)="onDatePickerClick(generationDate.open())" (click)="generationDate.open()"
              (dateInput)="setExpireMinDate($event)" (dateChange)="setExpireMinDate($event)" />
            <mat-datepicker-toggle matSuffix [for]="generationDate" data-test="select-date" data-testid="select-generation-date"></mat-datepicker-toggle>
            <mat-datepicker touchUi="true" #generationDate></mat-datepicker>
            @if (form.get('generationDate').invalid) {
            <mat-error data-testid="generation-date-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
          } @else {
            <div class="skeleton-input" data-testid="skeleton-generation-date">
              <span class="skeleton-label">Issue Date</span>
              <div class="skeleton-bar"></div>
            </div>
          }
        </div>
        }
        @if (hideTabs && isHealthCard) {
        <div class="view-date" [class.skeleton-field]="isExtracting">
          @if (!isExtracting) {
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Health Card Number</mat-label>
            <input matInput formControlName="healthCardNumber" required [disabled]="uploadedFile && !isExtractionSupported"
              data-test="fast-card-number" data-testid="health-card-number" />
            @if (form.get('healthCardNumber').invalid) {
            <mat-error data-testid="health-card-number-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
          } @else {
            <div class="skeleton-input" data-testid="skeleton-health-card-number">
              <span class="skeleton-label">Health Card Number</span>
              <div class="skeleton-bar"></div>
            </div>
          }
        </div>
        }
        @if (hideTabs && isIssued) {
        <div class="view-date" [class.skeleton-field]="isExtracting">
          @if (!isExtracting) {
          <div [class.date-field-row]="isHealthCard">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Issue Date</mat-label>
              <input matInput [matDatepicker]="issueDate" formControlName="issueDate" [required]="!isHealthCard" [max]="currentDate"
                [disabled]="uploadedFile && !isExtractionSupported" data-test="issue-date" data-testid="issue-date" readonly
                (focus)="onDatePickerClick(issueDate.open())" (click)="issueDate.open()"
                (dateInput)="setExpireMinDate($event)" (dateChange)="setExpireMinDate($event)" />
              <mat-datepicker-toggle matSuffix [for]="issueDate" data-test="select-date" data-testid="select-issue-date"></mat-datepicker-toggle>
              <mat-datepicker touchUi="true" #issueDate></mat-datepicker>
              @if (form.get('issueDate').invalid) {
              <mat-error data-testid="issue-date-error">
                {{ required }}
              </mat-error>
              }
            </mat-form-field>
            @if (isHealthCard && form.get('issueDate')?.value) {
              <button type="button" class="date-clear-btn" (click)="clearDateField('issueDate')" data-testid="clear-issue-date">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          } @else {
            <div class="skeleton-input" data-testid="skeleton-issue-date">
              <span class="skeleton-label">Issue Date</span>
              <div class="skeleton-bar"></div>
            </div>
          }
        </div>
        }
        @if (hideTabs && isExpiring && !isTrainingDocument) {
        <div class="view-date" [class.skeleton-field]="isExtracting">
          @if (!isExtracting) {
          <div [class.date-field-row]="isHealthCard">
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Expiration Date</mat-label>
              <input matInput [matDatepicker]="validToDate" formControlName="validToDate" [required]="!isHealthCard" [min]="expireMinDate"
                [disabled]="uploadedFile && !isExtractionSupported" data-test="valid-to-date" data-testid="valid-to-date"
                (focus)="onDatePickerClick(validToDate.open())" readonly (click)="validToDate.open()" />
              <mat-datepicker-toggle matSuffix [for]="validToDate" data-test="select-date" data-testid="select-valid-to-date"></mat-datepicker-toggle>
              <mat-datepicker touchUi="true" #validToDate></mat-datepicker>
              @if (form.get('validToDate').invalid) {
              <mat-error data-testid="valid-to-date-error">
                {{ required }}
              </mat-error>
              }
            </mat-form-field>
            @if (isHealthCard && form.get('validToDate')?.value) {
              <button type="button" class="date-clear-btn" (click)="clearDateField('validToDate')" data-testid="clear-valid-to-date">
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
          } @else {
            <div class="skeleton-input" data-testid="skeleton-valid-to-date">
              <span class="skeleton-label">Expiration Date</span>
              <div class="skeleton-bar"></div>
            </div>
          }
        </div>
        }
        @if (hideTabs && isExpiring && isTrainingDocument) {
        <div class="view-date">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Expiration Date</mat-label>
            <input matInput [matDatepicker]="validToDate" formControlName="validToDate" [min]="expireMinDate"
              [disabled]="uploadedFile" data-test="valid-to-date" data-testid="expiry-date"
              (focus)="onDatePickerClick(validToDate.open())" readonly (click)="validToDate.open()" />
            <mat-datepicker-toggle matSuffix [for]="validToDate" data-test="select-date" data-testid="select-valid-to-date"></mat-datepicker-toggle>
            <mat-datepicker touchUi="true" #validToDate></mat-datepicker>
            @if (form.get('validToDate').invalid) {
            <mat-error data-testid="expiry-date-error" error>
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (hideTabs && isFastCard) {
        <div class="view-date" [class.skeleton-field]="isExtracting">
          @if (!isExtracting) {
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>FAST Card Number</mat-label>
            <input matInput formControlName="fastCardNumber" required [disabled]="uploadedFile && !isExtractionSupported"
              data-test="fast-card-number" data-testid="fast-card-number" />
            @if (form.get('fastCardNumber').invalid) {
            <mat-error data-testid="fast-card-number-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
          } @else {
            <div class="skeleton-input" data-testid="skeleton-fast-card-number">
              <span class="skeleton-label">FAST Card Number</span>
              <div class="skeleton-bar"></div>
            </div>
          }
        </div>
        }
        @if (hideTabs && isTrainingDocument) {
        <div class="view-date">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Certificate Name</mat-label>
            <input matInput formControlName="trainingCertificationName" [disabled]="uploadedFile"
              data-test="fast-card-number" data-testid="cert-name" required />
            @if (form.get('trainingCertificationName').invalid) {
            <mat-error data-testid="cert-name-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (hideTabs && isTrainingDocument) {
        <div class="view-date">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Issuing Organization</mat-label>
            <input matInput formControlName="issuingOrganization" [disabled]="uploadedFile" data-test="fast-card-number"
              data-testid="issuingOrg" required />
            @if (form.get('issuingOrganization').invalid) {
            <mat-error data-testid="issuingOrg-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (hideTabs && isTrainingDocument) {
        <div class="view-date">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Credential ID</mat-label>
            <input matInput formControlName="credentialId" [disabled]="uploadedFile" data-test="fast-card-number"
              data-testid="credId" />
            @if (form.get('credentialId').invalid) {
            <mat-error data-testid="credId-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        @if (hideTabs && isTrainingDocument) {
        <div class="view-date">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Credential URL</mat-label>
            <input matInput formControlName="credentialUrl" [disabled]="uploadedFile" data-test="fast-card-number"
              data-testid="credUrl" />
            @if (form.get('credentialUrl').invalid) {
            <mat-error data-testid="credUrl-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
        </div>
        }
        <ng-template [ngTemplateOutlet]="additonalDocumentValidToDate"></ng-template>

        <!-- Old-style dashed Add File button — only for non-extraction docs -->
        @if (!isExtractionSupported && !uploadedFile) {
        <div [ngClass]="
        (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
        (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
        (!isFastCard || form.get('fastCardNumber')?.value) &&
        (!isHealthCard || form.get('healthCardNumber')?.value) &&
        (!isTrainingDocument || form.get('issuingOrganization')?.value) &&
        !isUploading
          ? 'add-file'
          : 'add-file-disabled'
      " [attr.data-testid]="
        (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
        (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
        (!isFastCard || form.get('fastCardNumber')?.value) &&
        (!isHealthCard || form.get('healthCardNumber')?.value) &&
        (!isTrainingDocument || form.get('issuingOrganization')?.value) &&
        !isUploading
          ? 'uploadBtn-enabled'
          : 'uploadBtn-disabled'
      " (click)="
        (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
        (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
        (!isFastCard || form.get('fastCardNumber')?.value) &&
        (!isHealthCard || form.get('healthCardNumber')?.value) &&
        !isUploading
          ? onAddFileClick(pictureSingle, uploadMultiple)
          : null
      ">
          <div class="add-file-content"><mat-icon svgIcon="icon-file-blue" class="icon-color"></mat-icon> + Add File
          </div>
        </div>
        }

        <div class="inputs-container">
          <input #uploadMultiple type="file" [accept]="acceptTypesMultiple" (change)="onUploadFileChange($event)"
            [disabled]="
          (!isExtractionSupported && !isPRCard && !(form.get('generationDate')?.value || form.get('issueDate')?.value)) ||
          (!isExtractionSupported && expiryMandatoryDocument.includes(form.get('documentType')?.value) && !form.get('validToDate')?.value) ||
          (!isExtractionSupported && isFastCard && !form.get('fastCardNumber')?.value) ||
          (!isExtractionSupported && isHealthCard && !form.get('healthCardNumber')?.value) ||
          isUploading
        " data-test="add-file" data-testid="addPages" />
          <input #pictureSingle type="file" name="image" [accept]="acceptTypesPicture" capture="environment"
            (change)="onProcessPictureFile($event)" [disabled]="
          (!isExtractionSupported && !isPRCard && !(form.get('generationDate')?.value || form.get('issueDate')?.value)) ||
          (!isExtractionSupported && expiryMandatoryDocument.includes(form.get('documentType')?.value) && !form.get('validToDate')?.value) ||
          (!isExtractionSupported && isFastCard && !form.get('fastCardNumber')?.value) ||
          (!isExtractionSupported && isHealthCard && !form.get('healthCardNumber')?.value) ||
          isUploading
        " data-test="add-file" data-testid="addSingle" />
        </div>

        @if (uploadError) {
          <mat-error>{{ uploadError }}</mat-error>
        }


      </form>
      }

    </div>
    }
  </div>

  <!-- Template for Add File tab content -->
  <ng-template #additonalDocumentUpload>
    <form [formGroup]="form">
      @if (!isFastCard && !isHealthCard && !isTrainingDocument && !isPRCard) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Issue Date</mat-label>
          <input matInput [matDatepicker]="generationDate" formControlName="generationDate" required [max]="currentDate"
            [disabled]="uploadedFile" data-test="generation-date" data-testid="generation-date" readonly
            (focus)="onDatePickerClick(generationDate.open())" (click)="generationDate.open()"
            (dateInput)="setExpireMinDate($event)" (dateChange)="setExpireMinDate($event)" />
          <mat-datepicker-toggle matSuffix [for]="generationDate" data-test="select-date" data-testid="select-generation-date"></mat-datepicker-toggle>
          <mat-datepicker touchUi="true" #generationDate></mat-datepicker>
          @if (form.get('generationDate').invalid) {
          <mat-error data-testid="generation-date-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isHealthCard) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Health Card Number</mat-label>
          <input matInput formControlName="healthCardNumber" required [disabled]="uploadedFile"
            data-test="fast-card-number" data-testid="health-card-number" />
          @if (form.get('healthCardNumber').invalid) {
          <mat-error data-testid="health-card-number-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isIssued) {
      <div class="view-date">
        <div [class.date-field-row]="isHealthCard">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Issue Date</mat-label>
            <input matInput [matDatepicker]="issueDate" formControlName="issueDate" [required]="!isHealthCard" [max]="currentDate"
              [disabled]="uploadedFile" data-test="issue-date" data-testid="issue-date" readonly
              (focus)="onDatePickerClick(issueDate.open())" (click)="issueDate.open()"
              (dateInput)="setExpireMinDate($event)" (dateChange)="setExpireMinDate($event)" />
            <mat-datepicker-toggle matSuffix [for]="issueDate" data-test="select-date" data-testid="select-issue-date"></mat-datepicker-toggle>
            <mat-datepicker touchUi="true" #issueDate></mat-datepicker>
            @if (form.get('issueDate').invalid) {
            <mat-error data-testid="issue-date-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
          @if (isHealthCard && form.get('issueDate')?.value) {
            <button type="button" class="date-clear-btn" (click)="clearDateField('issueDate')" data-testid="clear-issue-date">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
      }
      @if (!hideTabs && isExpiring && !isTrainingDocument) {
      <div class="view-date">
        <div [class.date-field-row]="isHealthCard">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Expiration Date</mat-label>
            <input matInput [matDatepicker]="validToDate" formControlName="validToDate" [required]="!isHealthCard" [min]="expireMinDate"
              [disabled]="uploadedFile" data-test="valid-to-date" data-testid="valid-to-date"
              (focus)="onDatePickerClick(validToDate.open())" readonly (click)="validToDate.open()" />
            <mat-datepicker-toggle matSuffix [for]="validToDate" data-test="select-date" data-testid="select-valid-to-date"></mat-datepicker-toggle>
            <mat-datepicker touchUi="true" #validToDate></mat-datepicker>
            @if (form.get('validToDate').invalid) {
            <mat-error data-testid="valid-to-date-error">
              {{ required }}
            </mat-error>
            }
          </mat-form-field>
          @if (isHealthCard && form.get('validToDate')?.value) {
            <button type="button" class="date-clear-btn" (click)="clearDateField('validToDate')" data-testid="clear-valid-to-date">
              <mat-icon>close</mat-icon>
            </button>
          }
        </div>
      </div>
      }
      @if (!hideTabs && isFastCard) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>FAST Card Number</mat-label>
          <input matInput formControlName="fastCardNumber" required [disabled]="uploadedFile"
            data-test="fast-card-number" data-testid="fast-card-number" />
          @if (form.get('fastCardNumber').invalid) {
          <mat-error data-testid="fast-card-number-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isTrainingDocument) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Certificate Name</mat-label>
          <input matInput formControlName="trainingCertificationName" [disabled]="uploadedFile"
            data-test="fast-card-number" data-testid="cert-name" required />
          @if (form.get('trainingCertificationName').invalid) {
          <mat-error data-testid="cert-name-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isTrainingDocument) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Issuing Organization</mat-label>
          <input matInput formControlName="issuingOrganization" [disabled]="uploadedFile" data-test="fast-card-number"
            data-testid="issuingOrg" required />
          @if (form.get('issuingOrganization').invalid) {
          <mat-error data-testid="issuingOrg-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isTrainingDocument) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Credential ID</mat-label>
          <input matInput formControlName="credentialId" [disabled]="uploadedFile" data-test="fast-card-number"
            data-testid="credId" />
          @if (form.get('credentialId').invalid) {
          <mat-error data-testid="credId-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      @if (!hideTabs && isTrainingDocument) {
      <div class="view-date">
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Credential URL</mat-label>
          <input matInput formControlName="credentialUrl" [disabled]="uploadedFile" data-test="fast-card-number"
            data-testid="credUrl" />
          @if (form.get('credentialUrl').invalid) {
          <mat-error data-testid="credUrl-error">
            {{ required }}
          </mat-error>
          }
        </mat-form-field>
      </div>
      }
      <ng-template [ngTemplateOutlet]="additonalDocumentValidToDate"></ng-template>
      @if (!uploadedFile) {
      <div [ngClass]="
          (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
          (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
          (!isFastCard || form.get('fastCardNumber')?.value) &&
          (!isHealthCard || form.get('healthCardNumber')?.value) &&
          (!isTrainingDocument || form.get('issuingOrganization')?.value) &&
          !isUploading
            ? 'add-file'
            : 'add-file-disabled'
        " [attr.data-testid]="
          (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
          (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
          (!isFastCard || form.get('fastCardNumber')?.value) &&
          (!isHealthCard || form.get('healthCardNumber')?.value) &&
          (!isTrainingDocument || form.get('issuingOrganization')?.value) &&
          !isUploading
            ? 'uploadBtn-enabled'
            : 'uploadBtn-disabled'
        " (click)="
          (isPRCard || form.get('generationDate')?.value || form.get('issueDate')?.value) &&
          (!expiryMandatoryDocument.includes(documentType) || form.get('validToDate')?.value) &&
          (!isFastCard || form.get('fastCardNumber')?.value) &&
          (!isHealthCard || form.get('healthCardNumber')?.value) &&
          !isUploading
            ? onAddFileClick(pictureSingle, uploadMultiple)
            : null
        ">
        <div class="add-file-content"><mat-icon svgIcon="icon-file-blue" class="icon-color"></mat-icon> + Add File</div>
      </div>
      }
      <div class="inputs-container">
        <input #uploadMultiple type="file" [accept]="acceptTypesMultiple" (change)="onUploadFileChange($event)"
          [disabled]="
          (!isPRCard && !(form.get('generationDate')?.value || form.get('issueDate')?.value)) ||
          (expiryMandatoryDocument.includes(form.get('documentType')?.value) && !form.get('validToDate')?.value) ||
          (!isExtractionSupported && isFastCard && !form.get('fastCardNumber')?.value) ||
          (!isExtractionSupported && isHealthCard && !form.get('healthCardNumber')?.value) ||
          isUploading
        " data-test="add-file" data-testid="addPages" />
        <input #pictureSingle type="file" name="image" [accept]="acceptTypesPicture" capture="environment"
          (change)="onProcessPictureFile($event)" [disabled]="
          (!isPRCard && !(form.get('generationDate')?.value || form.get('issueDate')?.value)) ||
          (expiryMandatoryDocument.includes(form.get('documentType')?.value) && !form.get('validToDate')?.value) ||
          (!isExtractionSupported && isFastCard && !form.get('fastCardNumber')?.value) ||
          (!isExtractionSupported && isHealthCard && !form.get('healthCardNumber')?.value) ||
          isUploading
        " data-test="add-file" data-testid="addSingle" />
      </div>
      @if (uploadError) {
      <mat-error>
        {{ uploadError }}
      </mat-error>
      }
    </form>
  </ng-template>

<!-- Template for additional document validation date fields -->
<ng-template #additonalDocumentValidToDate>
  <!-- This template can be used for additional date validation fields if needed -->
</ng-template>